(function () {
  if (window.rdPdpInit) return;
  window.rdPdpInit = true;

  const money = (cents) => '$' + Math.round(Number(cents) / 100).toLocaleString('en-US');

  const initProduct = (root) => {
    const variants = JSON.parse(root.querySelector('[data-rd-pdp-variants]').textContent);
    const copy = JSON.parse(root.querySelector('[data-rd-pdp-copy]').textContent);
    const idInput = root.querySelector('[data-rd-pdp-id]');
    const priceEl = root.querySelector('[data-rd-pdp-price]');
    const compareEl = root.querySelector('[data-rd-pdp-compare]');
    const installmentsEl = root.querySelector('[data-rd-pdp-installments]');
    const saleEl = root.querySelector('[data-rd-pdp-sale]');
    const stockEl = root.querySelector('[data-rd-pdp-stock]');
    const addButton = root.querySelector('[data-rd-pdp-add]');
    const addLabel = root.querySelector('[data-rd-pdp-add-label]');
    const sticky = root.querySelector('[data-rd-pdp-sticky]');
    const stickyPrice = root.querySelector('[data-rd-pdp-sticky-price]');
    const stickyColor = root.querySelector('[data-rd-pdp-sticky-color]');
    const stickyAdd = root.querySelector('[data-rd-pdp-sticky-add]');
    const stickySizes = [...root.querySelectorAll('[data-rd-pdp-sticky-option]')];
    const colorName = root.querySelector('[data-rd-pdp-color-name]');
    const buttons = [...root.querySelectorAll('[data-rd-pdp-option]')];

    const selected = {};
    buttons.forEach((button) => {
      if (button.classList.contains('is-selected')) {
        selected[button.dataset.position] = button.dataset.value;
      }
    });

    const matchVariant = (next) =>
      variants.find((variant) =>
        Object.entries(next).every(([position, value]) => variant['option' + position] === value)
      );

    const sizeAvailable = (button) => {
      const position = button.dataset.position;
      const trial = { ...selected, [position]: button.dataset.value };
      return variants.some(
        (variant) =>
          variant.available &&
          Object.entries(trial).every(([key, value]) => variant['option' + key] === value)
      );
    };

    const paintSizes = () => {
      buttons.forEach((button) => {
        const isSize = button.classList.contains('rd-pdp__size');
        if (!isSize) return;
        const available = sizeAvailable(button);
        button.disabled = !available;
        button.classList.toggle('is-selected', selected[button.dataset.position] === button.dataset.value);
        button.setAttribute('aria-pressed', selected[button.dataset.position] === button.dataset.value ? 'true' : 'false');
      });
      buttons
        .filter((button) => button.classList.contains('rd-pdp__swatch'))
        .forEach((button) => {
          const on = selected[button.dataset.position] === button.dataset.value;
          button.classList.toggle('is-selected', on);
          button.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      stickySizes.forEach((stickyButton) => {
        const main = buttons.find(
          (button) =>
            button.dataset.position === stickyButton.dataset.position && button.dataset.value === stickyButton.dataset.value
        );
        stickyButton.classList.toggle('is-selected', Boolean(main?.classList.contains('is-selected')));
        stickyButton.classList.toggle('is-out', !main || main.disabled);
      });
    };

    const paintStock = (variant, sizeLabel) => {
      if (!stockEl) return;
      const units = Number(variant.inventory_quantity);
      const low = Boolean(variant.inventory_management) && units > 0 && units <= 2;
      const template = units === 1 ? copy.stockOne : copy.stock;
      stockEl.hidden = !low;
      stockEl.textContent = low ? template.replace('[n]', units).replace('[size]', sizeLabel) : '';
    };

    const applyVariant = (variant) => {
      if (!variant) return;
      idInput.value = variant.id;
      priceEl.textContent = money(variant.price);
      if (stickyPrice) stickyPrice.textContent = money(variant.price);
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.hidden = false;
        compareEl.textContent = money(variant.compare_at_price);
      } else {
        compareEl.hidden = true;
        compareEl.textContent = '';
      }
      if (saleEl) {
        const onSale = variant.compare_at_price > variant.price;
        saleEl.hidden = !onSale;
        if (onSale) {
          saleEl.textContent =
            '-' + Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price) + '%';
        }
      }
      const installment = Math.round(variant.price / 100 / 4) * 100;
      installmentsEl.textContent = copy.installments.replace('[n]', '4').replace('[amount]', money(installment));
      const sizeValue = selected[buttons.find((button) => button.classList.contains('rd-pdp__size'))?.dataset.position];
      paintStock(variant, sizeValue || variant.title);
      addLabel.textContent = variant.available ? copy.add : copy.soldOut;
      addButton.disabled = !variant.available;
      addButton.toggleAttribute('aria-disabled', !variant.available);
      if (stickyAdd) {
        stickyAdd.disabled = !variant.available;
        stickyAdd.textContent = variant.available ? copy.add : copy.soldOut;
      }
      if (colorName) {
        const colorButton = buttons.find(
          (button) => button.classList.contains('rd-pdp__swatch') && button.classList.contains('is-selected')
        );
        if (colorButton) {
          colorName.textContent = colorButton.dataset.value;
          if (stickyColor) stickyColor.textContent = colorButton.dataset.value.toUpperCase();
        }
      }
      if (variant.featured_media && variant.featured_media.id) {
        const slide = root.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
        if (slide) slide.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        if (button.disabled) return;
        selected[button.dataset.position] = button.dataset.value;
        let variant = matchVariant(selected);
        if (!variant || !variant.available) {
          variant =
            variants.find((item) => {
              if (!item.available) return false;
              return Object.keys(selected).every((position) => {
                const expected = position === button.dataset.position ? button.dataset.value : selected[position];
                return item['option' + position] === expected;
              });
            }) || variants.find((item) => item.available && item['option' + button.dataset.position] === button.dataset.value);
        }
        if (!variant) {
          paintSizes();
          return;
        }
        ['1', '2', '3'].forEach((position) => {
          if (variant['option' + position]) selected[position] = variant['option' + position];
        });
        paintSizes();
        applyVariant(variant);
      });
    });

    paintSizes();

    // Metafield content often repeats the accordion title as its own heading.
    root.querySelectorAll('.rd-pdp__acc-panel').forEach((panel) => {
      panel.querySelectorAll('h1, h2, h3, h4, h5, h6').forEach((heading) => {
        const text = heading.textContent.trim();
        if (!text || /^descripci[oó]n$/i.test(text)) heading.remove();
      });
    });

    root.querySelectorAll('.rd-pdp__acc-btn').forEach((button) => {
      button.addEventListener('click', () => {
        const item = button.closest('.rd-pdp__acc');
        const panel = item.querySelector('.rd-pdp__acc-panel');
        const open = !item.classList.contains('is-open');
        item.classList.toggle('is-open', open);
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
        panel.hidden = !open;
      });
    });

    const reviewsLink = root.querySelector('.rd-pdp__reviews-link');
    if (reviewsLink) {
      reviewsLink.addEventListener('click', (event) => {
        const target = document.querySelector(reviewsLink.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
    }

    const wish = root.querySelector('[data-rd-pdp-wish]');
    if (wish) {
      const productId = wish.dataset.productId;
      const handle = wish.dataset.productHandle;
      const setWish = (on) => wish.setAttribute('aria-pressed', on ? 'true' : 'false');
      // Wishlist Guru keeps its list in a global lexical binding, not on window.
      const savedInApp = async () => {
        if (typeof window.checkFound !== 'function' || typeof allWishlistData === 'undefined') return null;
        try {
          return Boolean(await window.checkFound(allWishlistData, productId));
        } catch (error) {
          return null;
        }
      };
      const syncWish = async () => {
        const saved = await savedInApp();
        if (saved !== null) setWish(saved);
        return saved;
      };

      let tries = 0;
      const poll = setInterval(async () => {
        tries += 1;
        if ((await syncWish()) !== null || tries >= 20) clearInterval(poll);
      }, 500);

      wish.addEventListener('click', async (event) => {
        if (typeof window.collectionIconClick !== 'function') {
          setWish(wish.getAttribute('aria-pressed') !== 'true');
          return;
        }
        wish.disabled = true;
        try {
          await window.collectionIconClick(event, productId, handle);
        } finally {
          wish.disabled = false;
          await syncWish();
          setTimeout(syncWish, 1500);
        }
      });
    }

    const guide = root.querySelector('[data-rd-pdp-guide]');
    const openGuide = root.querySelector('[data-rd-pdp-guide-open]');
    const openPhotos = root.querySelector('[data-rd-pdp-photos]');
    const closeGuide = () => {
      if (!guide?.open || guide.classList.contains('is-closing')) return;
      const finish = () => {
        guide.classList.remove('is-closing');
        guide.close();
      };
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        finish();
        return;
      }
      guide.classList.add('is-closing');
      guide.addEventListener('animationend', finish, { once: true });
    };
    if (openGuide && guide) {
      openGuide.addEventListener('click', () => {
        guide.showModal();
        document.documentElement.classList.add('rd-pdp-modal-open');
      });
      guide.addEventListener('cancel', (event) => {
        event.preventDefault();
        closeGuide();
      });
      guide.addEventListener('close', () => document.documentElement.classList.remove('rd-pdp-modal-open'));
    }
    if (openPhotos) {
      const gallery = root.querySelector('.rd-pdp__gallery');
      openPhotos.addEventListener('click', () => {
        const expanded = gallery.classList.toggle('is-expanded');
        openPhotos.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        openPhotos.textContent = expanded ? openPhotos.dataset.labelLess : openPhotos.dataset.labelMore;
        if (!expanded) openPhotos.scrollIntoView({ block: 'nearest' });
      });
    }
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      const panTo = (slide, event) => {
        const box = slide.getBoundingClientRect();
        const x = ((event.clientX - box.left) / box.width) * 100;
        const y = ((event.clientY - box.top) / box.height) * 100;
        slide.style.setProperty('--rd-zoom-x', `${Math.min(100, Math.max(0, x))}%`);
        slide.style.setProperty('--rd-zoom-y', `${Math.min(100, Math.max(0, y))}%`);
      };
      root.querySelectorAll('.rd-pdp__slide').forEach((slide) => {
        const img = slide.querySelector('img');
        if (!img) return;
        slide.classList.add('is-zoomable');
        slide.addEventListener('click', (event) => {
          const zoomed = slide.classList.toggle('is-zoomed');
          if (zoomed) {
            img.sizes = '1400px';
            panTo(slide, event);
          }
        });
        slide.addEventListener('mousemove', (event) => {
          if (slide.classList.contains('is-zoomed')) panTo(slide, event);
        });
        slide.addEventListener('mouseleave', () => slide.classList.remove('is-zoomed'));
      });
    }
    root.querySelector('[data-rd-pdp-guide-close]')?.addEventListener('click', closeGuide);
    if (guide) {
      guide.addEventListener('click', (event) => {
        if (event.target === guide) closeGuide();
      });
    }
    root.querySelectorAll('[data-rd-pdp-guide-tab]').forEach((tab) => {
      tab.addEventListener('click', () => {
        root.querySelectorAll('[data-rd-pdp-guide-tab]').forEach((item) => {
          const on = item === tab;
          item.classList.toggle('is-selected', on);
          item.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        root.querySelectorAll('[data-rd-pdp-guide-panel]').forEach((panel) => {
          panel.hidden = panel.dataset.rdPdpGuidePanel !== tab.dataset.rdPdpGuideTab;
        });
      });
    });

    if (stickyAdd) {
      stickyAdd.addEventListener('click', () => {
        if (addButton.disabled) return;
        addButton.click();
      });
    }

    stickySizes.forEach((stickyButton) => {
      stickyButton.addEventListener('click', () => {
        const main = buttons.find(
          (button) =>
            button.dataset.position === stickyButton.dataset.position && button.dataset.value === stickyButton.dataset.value
        );
        if (main && !main.disabled) main.click();
      });
    });

    if (sticky && addButton) {
      const focusables = sticky.querySelectorAll('button');
      const setSticky = (on) => {
        sticky.classList.toggle('is-on', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        focusables.forEach((button) => (button.tabIndex = on ? 0 : -1));
      };
      let ticking = false;
      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          ticking = false;
          setSticky(addButton.getBoundingClientRect().bottom < 0);
        });
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  };

  const initLook = (root) => {
    const rail = root.querySelector('[data-rd-pdp-look-rail]');
    const productId = root.dataset.productId;
    const rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const prev = root.querySelector('[data-rd-pdp-look-prev]');
    const next = root.querySelector('[data-rd-pdp-look-next]');
    const el = (tag, className, text) => {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text != null) node.textContent = text;
      return node;
    };

    const imageUrl = (image) => {
      const src = typeof image === 'string' ? image : (image && (image.src || image.url)) || '';
      return src.indexOf('//') === 0 ? 'https:' + src : src;
    };

    const LOOK_WIDTHS = [300, 450, 600, 900];
    const LOOK_SIZES = '(min-width: 990px) 290px, (min-width: 750px) 40vw, 66vw';

    const sizedUrl = (src, width) => {
      try {
        const url = new URL(src, window.location.origin);
        url.searchParams.set('width', width);
        return url.toString();
      } catch (error) {
        return src;
      }
    };

    const lookImage = (src, className) => {
      const img = el('img', className);
      img.src = sizedUrl(src, 600);
      img.srcset = LOOK_WIDTHS.map((width) => `${sizedUrl(src, width)} ${width}w`).join(', ');
      img.sizes = LOOK_SIZES;
      img.width = 600;
      img.height = 750;
      img.loading = 'lazy';
      img.decoding = 'async';
      return img;
    };

    const card = (item) => {
      const image = imageUrl(item.featured_image);
      const hoverImage = imageUrl((item.images || [])[1]);
      const article = el('article', 'rd-pdp-look__card');
      const media = el('a', 'rd-pdp-look__media');
      media.href = item.url;
      if (image) {
        const img = lookImage(image);
        img.alt = item.title || '';
        media.appendChild(img);
      }
      if (image && hoverImage && hoverImage !== image) {
        const alt = lookImage(hoverImage, 'rd-pdp-look__hover');
        alt.alt = '';
        alt.setAttribute('aria-hidden', 'true');
        media.classList.add('has-hover');
        media.appendChild(alt);
      }
      const name = el('a', 'rd-pdp-look__name', item.title || '');
      name.href = item.url;
      const price = el('div', 'rd-pdp-look__price');
      if (item.compare_at_price && item.compare_at_price > item.price) {
        price.appendChild(el('s', 'rd-pdp-look__compare', money(item.compare_at_price)));
      }
      price.appendChild(el('span', '', money(item.price)));
      const meta = el('div', 'rd-pdp-look__meta');
      meta.append(name, price);
      article.append(media, meta);
      return article;
    };

    const updateNav = () => {
      if (!prev || !next) return;
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
    };

    const step = () => {
      const first = rail.querySelector('.rd-pdp-look__card');
      const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      return first ? first.getBoundingClientRect().width + gap : rail.clientWidth;
    };

    if (productId) {
      fetch(rootPath + 'recommendations/products.json?product_id=' + productId + '&limit=10')
        .then((response) => (response.ok ? response.json() : null))
        .then((data) => {
          const items = ((data && data.products) || []).filter((item) => item.available);
          if (!items.length) return;
          rail.replaceChildren(...items.map(card));
          rail.scrollLeft = 0;
          updateNav();
        })
        .catch(() => {});
    }

    if (prev) prev.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: 'smooth' }));
    rail.addEventListener('scroll', updateNav, { passive: true });
    window.addEventListener('resize', updateNav);
    updateNav();
  };

  const LOOX_API = 'https://storefront-api.loox.io/storefront/v1/store/';

  const reviewStars = (rating, label) => {
    const stars = document.createElement('span');
    stars.className = 'rd-pdp-stars rd-pdp-reviews__card-stars';
    stars.style.setProperty('--rd-stars', `${(rating / 5) * 100}%`);
    stars.setAttribute('role', 'img');
    stars.setAttribute('aria-label', (label || '[count]').replace('[count]', rating));
    return stars;
  };

  const renderBars = (root, bottomline) => {
    const bars = root.querySelector('[data-rd-pdp-reviews-bars]');
    const total = bottomline?.totalReviews;
    if (!bars || !total) return;
    bars.querySelectorAll('[data-star]').forEach((row) => {
      const count = Number(bottomline.ratingDistribution[row.dataset.star]) || 0;
      row.querySelector('i').style.width = `${(count / total) * 100}%`;
      row.querySelector('.rd-pdp-reviews__bar-count').textContent = count;
    });
    bars.hidden = false;
  };

  const looxSize = (url, suffix) => url.replace(/_orig(\.\w+)$/, `${suffix}$1`);
  const isVideo = (media) => media.type === 'video';
  const mediaThumb = (media) => (isVideo(media) ? media.thumbnailUrl : looxSize(media.url, ''));
  const reviewMedia = (review) => (review.media || []).filter((media) => media.url && mediaThumb(media));

  const fallbackToOriginal = (img, url) => {
    img.addEventListener(
      'error',
      () => {
        if (img.src !== url) img.src = url;
      },
      { once: true }
    );
  };

  const reviewHead = (review, root, dateFormat) => {
    const head = document.createElement('div');
    head.className = 'rd-pdp-reviews__card-head';
    head.append(reviewStars(review.rating, root.dataset.labelStars));
    const date = new Date(review.date || review.createdAt);
    if (!Number.isNaN(date.getTime())) {
      const time = document.createElement('time');
      time.className = 'rd-pdp-reviews__date';
      time.dateTime = date.toISOString();
      time.textContent = dateFormat.format(date);
      head.append(time);
    }
    return head;
  };

  const reviewText = (review) => {
    const text = document.createElement('p');
    text.className = 'rd-pdp-reviews__text';
    text.textContent = review.body.trim();
    return text;
  };

  const reviewAuthor = (review, root) => {
    const author = document.createElement('p');
    author.className = 'rd-pdp-reviews__author';
    author.textContent = review.reviewer?.name || '';
    if (review.verified && root.dataset.labelVerified) {
      const verified = document.createElement('span');
      verified.className = 'rd-pdp-reviews__verified';
      verified.textContent = root.dataset.labelVerified;
      author.append(verified);
    }
    return author;
  };

  const setModalSlide = (modal, index) => {
    const slides = [...modal.querySelectorAll('[data-review-modal-track] > *')];
    const current = Math.max(0, Math.min(index, slides.length - 1));
    modal.dataset.index = current;
    slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === current);
      const video = slide.querySelector('video');
      if (video && i !== current) video.pause();
    });
    modal.querySelector('[data-review-modal-prev]').disabled = current === 0;
    modal.querySelector('[data-review-modal-next]').disabled = current === slides.length - 1;
    modal.querySelector('[data-review-modal-counter]').textContent = `${current + 1} / ${slides.length}`;
  };

  const openReviewModal = (root, review, index, dateFormat) => {
    const modal = root.querySelector('[data-rd-pdp-review-modal]');
    const items = reviewMedia(review);
    if (!modal?.showModal) {
      window.open(items[index].url, '_blank', 'noopener');
      return;
    }
    modal.querySelector('[data-review-modal-track]').replaceChildren(
      ...items.map((media) => {
        const slide = document.createElement('div');
        slide.className = 'rd-pdp-review-modal__slide';
        if (isVideo(media)) {
          const video = document.createElement('video');
          video.src = media.url;
          video.poster = media.thumbnailUrl || '';
          video.controls = true;
          video.playsInline = true;
          video.preload = 'metadata';
          slide.append(video);
        } else {
          const img = document.createElement('img');
          img.src = looxSize(media.url, '_mid');
          img.alt = '';
          fallbackToOriginal(img, media.url);
          slide.append(img);
        }
        return slide;
      })
    );
    modal.querySelector('[data-review-modal-body]').replaceChildren(
      reviewHead(review, root, dateFormat),
      reviewText(review),
      reviewAuthor(review, root)
    );
    modal.classList.toggle('is-single', items.length < 2);
    setModalSlide(modal, index);
    modal.showModal();
    document.documentElement.classList.add('rd-pdp-modal-open');
  };

  const initReviewModal = (root) => {
    const modal = root.querySelector('[data-rd-pdp-review-modal]');
    if (!modal) return;
    const step = (delta) => setModalSlide(modal, Number(modal.dataset.index || 0) + delta);
    modal.querySelector('[data-review-modal-close]').addEventListener('click', () => modal.close());
    modal.querySelector('[data-review-modal-prev]').addEventListener('click', () => step(-1));
    modal.querySelector('[data-review-modal-next]').addEventListener('click', () => step(1));
    modal.addEventListener('click', (event) => {
      if (event.target === modal) modal.close();
    });
    modal.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') step(-1);
      if (event.key === 'ArrowRight') step(1);
    });
    modal.addEventListener('close', () => {
      modal.querySelectorAll('video').forEach((video) => video.pause());
      document.documentElement.classList.remove('rd-pdp-modal-open');
    });
  };

  const reviewCard = (review, root, dateFormat) => {
    const card = document.createElement('article');
    card.className = 'rd-pdp-reviews__card';
    const body = document.createElement('div');
    body.className = 'rd-pdp-reviews__card-body';
    body.append(reviewHead(review, root, dateFormat), reviewText(review), reviewAuthor(review, root));

    const items = reviewMedia(review);
    if (items.length) {
      const first = items[0];
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'rd-pdp-reviews__media';
      if (isVideo(first)) button.classList.add('is-video');
      button.addEventListener('click', () => openReviewModal(root, review, 0, dateFormat));
      const img = document.createElement('img');
      img.src = mediaThumb(first);
      img.alt = '';
      img.loading = 'lazy';
      if (!isVideo(first)) fallbackToOriginal(img, first.url);
      button.append(img);
      if (items.length > 1) {
        const count = document.createElement('span');
        count.className = 'rd-pdp-reviews__media-count';
        count.textContent = `+${items.length - 1}`;
        button.append(count);
      }
      card.classList.add('has-media');
      card.append(button);
    }

    card.append(body);
    return card;
  };

  const loadLoox = (root) => {
    const store = root.dataset.looxStore;
    const productId = root.dataset.productId;
    const list = root.querySelector('[data-rd-pdp-reviews-list]');
    const more = root.querySelector('[data-rd-pdp-reviews-more]');
    if (!store || !productId || !list || !window.fetch) return;
    const base = `${LOOX_API}${encodeURIComponent(store)}/product-reviews`;
    const getJson = (url) => fetch(url).then((response) => (response.ok ? response.json() : null)).catch(() => null);
    const dateFormat = new Intl.DateTimeFormat(document.documentElement.lang || 'es', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });
    let nextPage = null;
    let replaced = false;

    const addPage = (data) => {
      const cards = (data?.reviews || [])
        .filter((review) => review.body?.trim())
        .map((review) => reviewCard(review, root, dateFormat));
      if (!cards.length) return;
      if (replaced) list.append(...cards);
      else list.replaceChildren(...cards);
      replaced = true;
      nextPage = data.pagination?.hasMore ? data.pagination.nextPageUrl : null;
      if (more) more.hidden = !nextPage;
    };

    getJson(`${base}/bottomline/${productId}`).then((data) => renderBars(root, data));
    getJson(`${base}?product_id=${productId}&limit=20`).then(addPage);

    if (more) {
      more.addEventListener('click', () => {
        if (!nextPage) return;
        more.disabled = true;
        getJson(new URL(nextPage, LOOX_API).href)
          .then(addPage)
          .finally(() => {
            more.disabled = false;
          });
      });
    }
  };

  const initReviews = (root) => {
    initReviewModal(root);
    loadLoox(root);
    const toggle = root.querySelector('[data-rd-pdp-reviews-toggle]');
    const list = root.querySelector('[data-rd-pdp-reviews-list]');
    const write = root.querySelector('[data-rd-pdp-reviews-write]');

    if (toggle && list) {
      toggle.addEventListener('click', () => {
        const open = !root.classList.contains('is-expanded');
        root.classList.toggle('is-expanded', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        toggle.textContent = open ? toggle.dataset.labelClose : toggle.dataset.labelOpen;
        if (!open) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    if (write) {
      write.addEventListener('click', () => {
        const productId = write.dataset.productId;
        if (typeof window.looxWrite === 'function') window.looxWrite(productId);
        else window.LOOX?.showReviewForm?.(productId);
      });
    }
  };

  document.querySelectorAll('[data-rd-pdp]').forEach(initProduct);
  document.querySelectorAll('[data-rd-pdp-reviews]').forEach(initReviews);
  document.querySelectorAll('[data-rd-pdp-look]').forEach(initLook);
})();
